import { FRIDAY, MainDrawScheduleCode, TUESDAY } from 'constants/Draw';
import { Message } from 'semantic-ui-react';

const DrawInProgressMessage = ({
  drawCode = FRIDAY,
}: {
  drawCode?: MainDrawScheduleCode;
}) => {
  return (
    <Message
      info
      icon="hourglass half"
      header="Draw in progress..."
      content={
        drawCode === TUESDAY ? (
          <p style={{ marginTop: '0.6em' }}>
            We're drawing the winning numbers for the Tuesday draw right now!
            Please check back in a bit!
          </p>
        ) : (
          <p style={{ marginTop: '0.6em' }}>
            We're drawing the winning numbers for the Friday draw right now!
            Check out our Instagram{' '}
            <a
              href="https://www.instagram.com/daymadeuk/"
              target="_blank"
              style={{
                color: 'rgb(0,87,107)',
                textDecoration: 'underline',
                whiteSpace: 'normal',
              }}
            >
              @daymadeuk
            </a>{' '}
            where we reveal our winning numbers live or return to this page in a
            bit!
          </p>
        )
      }
      style={{ maxWidth: '500px', padding: '2em' }}
    />
  );
};

export default DrawInProgressMessage;
